module.exports = __webpack_public_path__ + "img/spam2.3dd8869b.png";